var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.8125C11.5076 3.8125 3.8125 11.5076 3.8125 21C3.8125 30.4924 11.5076 38.1875 21 38.1875C30.4924 38.1875 38.1875 30.4924 38.1875 21C38.1875 11.5076 30.4924 3.8125 21 3.8125ZM0.6875 21C0.6875 9.78172 9.78172 0.6875 21 0.6875C32.2183 0.6875 41.3125 9.78172 41.3125 21C41.3125 32.2183 32.2183 41.3125 21 41.3125C9.78172 41.3125 0.6875 32.2183 0.6875 21Z",
    fill: "#40A99E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3549 15.7285C28.965 16.3387 28.965 17.328 28.3549 17.9382L20.0215 26.2715C19.4113 26.8817 18.422 26.8817 17.8118 26.2715L13.6451 22.1048C13.035 21.4946 13.035 20.5053 13.6451 19.8951C14.2553 19.2849 15.2447 19.2849 15.8549 19.8951L18.9167 22.9569L26.1451 15.7285C26.7553 15.1183 27.7447 15.1183 28.3549 15.7285Z",
    fill: "#40A99E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSuccess);
export default __webpack_public_path__ + "static/media/check-success.0c2d0c19d520ecd809b787a46bfc29d7.svg";
export { ForwardRef as ReactComponent };